import { useEffect, useRef, useContext } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function useQuizNavigationBlocker(shouldBlock, onBlock) {
    const { navigator } = useContext(NavigationContext);
    const onBlockRef = useRef(onBlock);

    useEffect(() => {
        onBlockRef.current = onBlock;
    }, [onBlock]);

    useEffect(() => {
        if (!shouldBlock) return;
        if (!navigator) return;

        const origPush = navigator.push;
        const origReplace = navigator.replace;

        function blockNav(method) {
            return function (...args) {
                onBlockRef.current(() => method(...args));
            };
        }

        navigator.push = blockNav(origPush);
        navigator.replace = blockNav(origReplace);

        return () => {
            navigator.push = origPush;
            navigator.replace = origReplace;
        };
    }, [shouldBlock, navigator]);
} 